export const getParsedUsage = (
  usage: string | number,
  numberOfDecimals: number
): string => {
  const usageValue =
    typeof usage === "number"
      ? parseFloat(usage.toString())
      : parseFloat(usage);
  return Number.isNaN(usageValue)
    ? usage.toString()
    : usageValue.toFixed(numberOfDecimals);
};

export const checkIsPlausible = (
  usage: string,
  min: number,
  max: number,
  range = 0
) => {
  const parsedUsage = parseFloat(usage);
  const parsedMin = Math.max(min, 0);
  const parsedMax = Math.max(max, 0);
  const parsedRange = Math.max(range, 0);
  // If there is no usage set, it is plausible (but not valid in form), else we need to validate ranges
  return parsedUsage
    ? parsedUsage >= parsedMin - parsedRange &&
        parsedUsage <= parsedMax + parsedRange
    : true;
};
